import { Browser } from '@capacitor/browser';
import { isNativeApp } from './platform';

export const openExternalUrl = async (rawUrl) => {
  const url = new URL(rawUrl);
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) {
    throw new Error('Deze link kan niet worden geopend.');
  }
  if (isNativeApp()) {
    await Browser.open({ url: url.toString(), toolbarColor: '#09090b' });
  } else {
    window.location.assign(url.toString());
  }
};
